import styled, { css } from 'styled-components';

import { toRem } from '@wecasa/common/src/utils/styles';

/* Hide radio visually but remain accessible to screen readers. */
/* Source: https://polished.js.org/docs/#hidevisually */
export const HiddenInput = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: ${toRem(1)};
  margin: ${toRem(-1)};
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: ${toRem(1)};
`;

export const StylelessButton = styled.button`
  border: none;
  outline: none;
  background: none;
  text-decoration: none;
  cursor: pointer;
  padding: 0;
`;

export const inputStyleReset = css`
  appearance: none;
  border: none;
  outline: none;
  background: none;
  padding: 0;
`;

export const StylelessInput = styled.input`
  ${inputStyleReset}
`;

export const StylelessSelect = styled.select`
  ${inputStyleReset}
`;

export const StylelessTextarea = styled.textarea`
  ${inputStyleReset}
`;
